import { useEffect } from "react";
import { Bell } from "lucide-react";

/**
 * PushNotification — iOS-style banner that slides down from the top edge.
 * Auto-dismisses after `duration` ms. Tap to dismiss early.
 */
export default function PushNotification({ show, onDismiss, title, body, duration = 4500 }) {
  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => onDismiss?.(), duration);
    return () => clearTimeout(t);
  }, [show, duration, onDismiss]);

  if (!show) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] flex justify-center pointer-events-none"
      data-testid="push-notification"
    >
      <button
        onClick={onDismiss}
        className="pointer-events-auto mt-3 w-[92%] max-w-md bg-[#1F2420]/90 backdrop-blur-2xl text-white rounded-2xl px-4 py-3 flex items-start gap-3 shadow-[0_20px_50px_-15px_rgba(0,0,0,0.5)] animate-slide-down active:scale-[0.99] transition-transform"
        style={{ WebkitBackdropFilter: "blur(24px)" }}
      >
        <div className="w-9 h-9 rounded-[10px] bg-gradient-to-br from-[#D4A373] to-[#B8864F] flex items-center justify-center flex-shrink-0">
          <Bell size={16} className="text-white" strokeWidth={2} />
        </div>
        <div className="flex-1 min-w-0 text-left">
          <div className="flex items-center justify-between gap-2 mb-0.5">
            <span className="font-outfit text-[11px] uppercase tracking-[0.1em] text-white/60">Aavaa</span>
            <span className="font-manrope text-[10px] text-white/50">now</span>
          </div>
          <p className="font-outfit text-sm font-medium leading-tight">{title}</p>
          {body && <p className="font-manrope text-xs text-white/70 mt-0.5 leading-snug">{body}</p>}
        </div>
      </button>
    </div>
  );
}
